import { Button } from "@material-ui/core";
import { Create } from "@material-ui/icons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resendCodeAction,
  verifyNumberAction,
} from "../../../../../redux/user/userActions";
import {
  Form,
  CustomTextField,
  SubmitButton,
} from "../../../../../utils/formGenerator";
import { verifyNumberSchema } from "../../../../../utils/validationsSchema";
import {
  useRegisterActions,
  useRegisterState,
} from "../../../../components/contexts/authContext/AuthContextProvider";

function Step2() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { step, phoneNumber } = useRegisterState();
  const { setStep, setCodeNumber } = useRegisterActions();
  const [initialValues, setInitialValues] = useState({
    code: "",
    phone_number: phoneNumber,
  });

  const onSubmit = (values, { setSubmitting, resetForm, setStatus }) => {
    setSubmitting(true);
    dispatch(verifyNumberAction(values, history));
    setSubmitting(false);
  };
  const [timer, setTimer] = useState({
    min: 2,
    sec: 0,
  });

  const resetTimer = () => {
    setInitialValues((prev) => ({
      ...prev,
      code: "",
    }));
    // form.resetFields();
    setTimer(() => ({
      min: 2,
      sec: 0,
    }));
  };
  useEffect(() => {
    const interval = setInterval(() => {
      const { sec, min } = timer;

      if (sec > 0) {
        setTimer((prev) => ({
          ...prev,
          sec: sec - 1,
        }));
      }

      if (sec === 0) {
        if (min === 0) {
          clearInterval(interval);
        } else {
          setTimer(() => ({
            min: min - 1,
            sec: 59,
          }));
        }
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [timer]);

  const handleChange = (e) =>
    setInitialValues((prev) => ({
      ...prev,
      code: e.target.value,
    }));

  const resendCode = (phone_number) => {
    resetTimer();
    dispatch(resendCodeAction({ phone_number }));
  };
  return (
    <div>
      <p className="text-muted text-center mb-5">
        کد ارسالی به شماره همراه {phoneNumber} را وارد نمایید
      </p>
      <div className="mb-3">
        <Form
          enableReinitialize
          initialValues={initialValues}
          validationSchema={verifyNumberSchema}
          onSubmit={onSubmit}
        >
          <CustomTextField
            label="کد ارسال شده"
            name="code"
            placeholder="کد ارسالی به شماره همراه را وارد نمایید"
            value={initialValues.code}
            handleChange={handleChange}
            margin="normal"
          />
          <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
            <SubmitButton
              title="ارسال"
              className="btn-bg-gold"
              type="submit"
              variant="contained"
              size="large"
              // loading={setp2Loading}
            />
          </div>
        </Form>
      </div>
      <div className="d-flex align-items-center ">
        <div className="w-50">
          <span
            className={`${timer.min + timer.sec > 0
              ? "text-muted"
              : "text-primary cursor-pointer"
              } text-xs`}
            disabled={timer.min + timer.sec > 0}
            onClick={() =>
              timer?.min === 0 && resendCode(initialValues.phone_number)
            }
          >
            ارسال مجدد
          </span>
          <b className="px-4 py-1 text-sm font-bold w-4">
            {timer.min.toLocaleString("fa-IR")}:
            {timer.sec < 10
              ? `۰${timer.sec.toLocaleString("fa-IR")}`
              : timer.sec.toLocaleString("fa-IR")}
          </b>
        </div>
        <div>
          <Button
            className="btn-bg-gold"
            onClick={() => setStep(1)}
            startIcon={<Create className="mr-3" fontSize="small" />}
          >
            تغییر شماره
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Step2;
